var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.$t('settings.colorIndicator.title')}},[_c('c-color-indicator-field',{model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }